var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"chat-account-delete"},[_c('div',{staticClass:"chat-account-delete__content"},[_c('p',{staticClass:"chat-account-delete__text"},[_vm._v(_vm._s(_vm.accountDeleteText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }